// src/app/services/universal-auth.service.ts (Angular 5)
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './mts/user/user.service';

@Injectable()
export class PortalCommunicationService {
  public isStandalone = true;
  private authentication = 'authentication';

  constructor(
    private translate: TranslateService,
    private userService: UserService
  ) {
    this.startEnvironment();
  }

  getIsStandalone(): boolean {
    return this.isStandalone;
  }

  staticCheckIfStandalone(): boolean {
    return window.self === window.top;
  }

  private startEnvironment(): void {
    if (this.staticCheckIfStandalone()) {
      return;
    }
    this.isStandalone = false;
    this.listenForMessages();
  }

  private listenForMessages(): void {
    console.log('OPS_CLIENT', 'listenForMessages');
    window.addEventListener('message', (event) => {
      if (environment.allowedHostOrigins.indexOf(event.origin) === -1) {return;}
      this.handleMessage(event.data);
    });
  }

  private handleMessage(message: any): void {
    switch (message.type) {
      case 'AUTH_TOKEN':
        this.handleAuthToken(message);
        break;
      case 'AUTH_TOKEN_CLEAR':
        console.log('OPS_CLIENT', 'handleAuthTokenClear');
        this.handleAuthTokenClear(message);
        break;
      case 'CHANGE_LANGUAGE':
        this.handleChangeLanguage(message);
        break;
      default:
        break;
    }
  }

  private handleAuthToken(message: any): void {
    if (!message.authentication || message.authentication === '') {
      throw new Error('Authentication token is missing');
    }
    localStorage.setItem(this.authentication, JSON.stringify(message.authentication));
  }

  private handleAuthTokenClear(message: any): void {
    localStorage.removeItem(this.authentication);
  }

  private handleChangeLanguage(message: any): void {
    if (!message.langCode || message.langCode === '') {
      throw new Error('Language is missing');
    }
    const locale = message.langCode;

    this.changeLanguage(locale);
  }

  public changeLanguage(locale: string): void {
    if (this.translate.currentLang === locale) {
      return;
    }
    this.translate.use(locale);
    this.translate.setDefaultLang(locale);

    const lang = this.getLangObject(locale);
    console.warn('Language changed to:', locale);

    this.userService.updateSelfUserLang(lang).then(user => {

    });
  }

  getLangObject(locale: string){
    switch(locale){
      case "en":
        return {
          "id" : 1
        }
      case "es":
        return {
          "id": 2
        }
      case "ru":
        return {
          "id": 3
        }
      case "de":
        return {
          "id": 4
        }
    }
  }
}

